import css from './LandingTitle.module.css';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';

export const LandingTitle: React.FC = () => {
    const [isDesktop] = useMediaType();

    return (
        <div className={css.title}>
            {isDesktop
                ? 'You want to build? We will create a Bill of Materials for You!'
                : 'Revolutionize the process of building and renovating with \n' +
                  'Bill of Materials'}
        </div>
    );
};
